import { useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import { filtersFromSearch, filtersToSearch, type DashboardFilters } from './models'

/** Shareable dates/scope plus list-only band/search. List changes push history for back/forward. */
export function useDashboardFilters() {
  const [params, setParams] = useSearchParams()
  const filters = useMemo(() => filtersFromSearch(params), [params])
  const set = (next: DashboardFilters, options: { replace?: boolean } = { replace: true }) => setParams(filtersToSearch(next), options)
  return { filters, set }
}
